var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetrics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    stroke: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1681_21838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2.625V9H14.875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.125 9C2.125 9.83718 2.28989 10.6662 2.61027 11.4396C2.93064 12.2131 3.40022 12.9158 3.99219 13.5078C4.58417 14.0998 5.28694 14.5694 6.06039 14.8897C6.83384 15.2101 7.66282 15.375 8.5 15.375C9.33718 15.375 10.1662 15.2101 10.9396 14.8897C11.7131 14.5694 12.4158 14.0998 13.0078 13.5078C13.5998 12.9158 14.0694 12.2131 14.3897 11.4396C14.7101 10.6662 14.875 9.83718 14.875 9C14.875 8.16282 14.7101 7.33384 14.3897 6.56039C14.0694 5.78694 13.5998 5.08417 13.0078 4.49219C12.4158 3.90022 11.7131 3.43064 10.9396 3.11027C10.1662 2.78989 9.33718 2.625 8.5 2.625C7.66282 2.625 6.83384 2.78989 6.06039 3.11027C5.28694 3.43064 4.58417 3.90022 3.99219 4.49219C3.40022 5.08417 2.93064 5.78694 2.61027 6.56039C2.28989 7.33384 2.125 8.16282 2.125 9Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1681_21838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetrics);
export default __webpack_public_path__ + "static/media/metrics.cbdef53c2d4ac8a5347f099f2bc3273e.svg";
export { ForwardRef as ReactComponent };